import { atom } from "recoil";
import { AuthState } from "../types/auth";

export const authState = atom<AuthState>({
  key: "authState",
  default: {
    isAuthenticated: false,
    user: null,
    loading: false,
    error: null,
  },
});

export const cloudConfigStatusState = atom({
  key: "cloudConfigStatus",
  default: {
    isConfigured: false,
    provider: null as string | null,
  },
});
